import { Injectable } from '@angular/core';
import { PartsDataService } from '../data-services/parts-data.service';
import { DealerPartsListviewModel, LaborchargingGroup, PartSalesPriceCalculation } from '../business-entities/dealer-parts-list-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { PartCostPriceModel, PartInventoryModel, PartNumberModel, PartsListViewModel, PartStatusInventoryModel } from '../business-entities/parts-list-view-model';

@Injectable({
  providedIn: 'root'
})
export class PartsBusinessService {
  dealerPartsList: DealerPartsListviewModel;
  partsList: PartsListViewModel[];
  partNumberModel : PartNumberModel[];
  partId: number;
  costType: string;
  isEdit: boolean = false;
  locationCode: string;
  selectedPartListWithAddtionalItems: PartsListViewModel[];
  searchPartNumber: string;
  partInventoryModel: PartInventoryModel;
  partInventoryList: PartInventoryModel[];
  partStatusInventoryList: PartStatusInventoryModel[];
  partCostPriceList : PartCostPriceModel[];
  partNumber:string;

  partSalesPriceCalculationRequestmodel : PartSalesPriceCalculation = {
    searchTearm : '',
    sortColumn : '',
    sortDirection: '',
    startRecordNumber : 0,
    numberOfRecord : 25,
    makeCode : '',
    itemSalesPriceGroup : ''
  }
  laborchargingGroupRequestmodel : LaborchargingGroup = {
    searchTearm : '',
    sortColumn : '',
    sortDirection: '',
    startRecordNumber : 0,
    numberOfRecord : 25,
    laborPriceGroup : '',
    chargingGroupNo : ''
  }

  constructor(private service: PartsDataService) { }

  addParts(model: any): Promise<any> {
    return this.service.addParts(model);
  }
  async getDealerPartsList(DealerId: string): Promise<DealerPartsListviewModel> {
    await this.service
      .getDealerPartsList(DealerId)
      .then(
        (res: GenericResponse<DealerPartsListviewModel>) => {
          this.dealerPartsList = res.responseObject;
        }
      );
    return this.dealerPartsList;
  }
  async getPartsList(cost: string, languageCode: string) {
    await this.service
      .getPartsList(cost, languageCode)
      .then(
        (res: GenericResponse<Array<PartsListViewModel>>) => {
          this.partsList = res.responseObject;
        }
      );
    return this.partsList;
  }
  async getPartById(partNumber: string) {
    return this.service.getPartById(partNumber);
  }
  async getParts(model: any): Promise<any> {
    await this.service
      .getParts(model)
      .then(
        (res: GenericResponse<Array<PartsListViewModel>>) => {
          this.partsList = res.responseObject;
        }
      );
    return this.partsList;
  }
  async GetPartLocation(model: any): Promise<any> {
    await this.service
      .GetPartLocation(model)
      .then(
        (res: GenericResponse<Array<PartsListViewModel>>) => {
          this.partsList = res.responseObject;
        }
      );
    return this.partsList;
  }
  async GetAlternativeParts(model: any): Promise<any> {
    await this.service
      .GetAlternativeParts(model)
      .then(
        (res: GenericResponse<Array<PartsListViewModel>>) => {
          this.partsList = res.responseObject;
        }
      );
    return this.partsList;
  }
  async GetAdditionalParts(model: any): Promise<any> {
    await this.service
      .GetAdditionalParts(model)
      .then(
        (res: GenericResponse<Array<PartsListViewModel>>) => {
          this.partsList = res.responseObject;
        }
      );
    return this.partsList;
  }
  async GetReplacementParts(model: any): Promise<any> {
    await this.service
      .GetReplacementParts(model)
      .then(
        (res: GenericResponse<Array<PartsListViewModel>>) => {
          this.partsList = res.responseObject;
        }
      );
    return this.partsList;
  }

  async GetFinalPartsWithAdditional(model: any): Promise<any> {
    await this.service
      .GetFinalPartsWithAdditional(model)
      .then(
        (res: GenericResponse<Array<PartsListViewModel>>) => {
          this.partsList = res.responseObject;
        }
      );
    return this.partsList;
  }

  async GetInventoryParts(model: any) {
    await this.service
        .GetInventoryParts(model)
        .then(
            (res: GenericResponse<PartInventoryModel>) => {
                this.partInventoryModel = res.responseObject;
            }
        );
    return this.partInventoryModel;
  }
  async GetPartDetails(model: any): Promise<any> {
    await this.service
      .GetPartDetails(model)
      .then(
        (res: GenericResponse<Array<PartsListViewModel>>) => {
          this.partsList = res.responseObject;
        }
      );
    return this.partsList;
  }
  async GetPartSalesPriceList(model: any) : Promise<any>{
    return this.service.GetPartSalesPriceList(model);
  }
  async GetLaborChargingGroupPrice(model: any) : Promise<any>{
    return this.service.GetLaborChargingGroupPrice(model);
  }

  async GetMultiInventoryParts(model: any) {
    await this.service
    .GetMultiInventoryParts(model)
    .then(
      (res: GenericResponse<Array<PartInventoryModel>>) => {
        this.partInventoryList = res.responseObject;
      }
    );
    return this.partInventoryList;

  }
  async GetPartCostPriceDetails(model: any) {
    await this.service
    .GetPartCostPriceDetails(model)
    .then(
      (res: GenericResponse<Array<PartCostPriceModel>>) => {
        this.partCostPriceList = res.responseObject;
      }
    );
    return this.partCostPriceList;

  }
  async GetItemStatusAndInventoryList(model: any) {
    await this.service
    .GetItemStatusAndInventoryList(model)
    .then(
      (res: GenericResponse<Array<PartStatusInventoryModel>>) => {
        this.partStatusInventoryList = res.responseObject;
      }
    );
    return this.partStatusInventoryList;

  }
}
